import script from "./useButton.vue?vue&type=script&setup=true&lang=js"
export * from "./useButton.vue?vue&type=script&setup=true&lang=js"

import "./useButton.vue?vue&type=style&index=0&id=c728e7ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c728e7ce"]])

export default __exports__